import { render } from "./FertilitiBetina.vue?vue&type=template&id=56450e99"
import script from "./FertilitiBetina.vue?vue&type=script&lang=js"
export * from "./FertilitiBetina.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__